import { render, staticRenderFns } from "./InventoryChargeModalComponent.vue?vue&type=template&id=0b71151e"
import script from "./InventoryChargeModalComponent.vue?vue&type=script&lang=js"
export * from "./InventoryChargeModalComponent.vue?vue&type=script&lang=js"
import style0 from "./InventoryChargeModalComponent.vue?vue&type=style&index=0&id=0b71151e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports